import { render, staticRenderFns } from "./discrimination-dialog-sex.vue?vue&type=template&id=9f7c99b6"
import script from "./discrimination-dialog-sex.vue?vue&type=script&lang=js"
export * from "./discrimination-dialog-sex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports